import {Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, signal, ViewChild} from '@angular/core';
import {Form, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {FieldSettingsModel, ListViewComponent} from '@syncfusion/ej2-angular-lists';
import {HtmlEditorService, ImageService, LinkService, ToolbarService} from '@syncfusion/ej2-angular-richtexteditor';
import jsPDF from 'jspdf';
import {catchError, concatMap, debounceTime, filter, tap} from 'rxjs/operators';
import {DokumentModels} from 'src/app/models/dokument-models';
import {MainDataModels} from 'src/app/models/maindata-models';
import {ObjektModels} from 'src/app/models/objekt-models';
import {DatumFormatPipe} from 'src/app/pipes/datum-format.pipe';
import {DokumentDataService} from 'src/app/services/dokument-data.service';
import {MainDataService} from 'src/app/services/main-data.service';
import {SwissSettingsService} from 'src/app/services/swiss-settings.service';
import {v4 as uuidv4} from 'uuid';
import {ObjektDataService, TreeViewItemSmall, TreeViewItemsResponseObject} from '../../services/objekt-data.service';
import {SwissFieldControlService} from '../../services/swissfieldcontrol.service';
import {SwissFieldBase} from '../../swiss-forms/fields/swiss-field-base';
import {AufgabeEintragComponent} from '../pendenzen/aufgabe-eintrag/aufgabe-eintrag.component';
import {NotizEintragComponent} from '../pendenzen/notiz-eintrag/notiz-eintrag.component';
import {TerminEintragComponent} from '../pendenzen/termin-eintrag/termin-eintrag.component';
import {ObjektAdresseComponent} from './objekt-adresse/objekt-adresse.component';
import {SwissAppConfigModels} from 'src/app/models/swissappconfig-models';
import {MessageBoxService} from 'src/app/services/message-box.service';
import {CameraViewerComponent} from '../camera-viewer/camera-viewer.component';
import {HomeLayoutComponent} from '../home-layout.component';
import {ImageEditorComponent} from '../image-editor/image-editor.component';
import {ObjektRapportComponent} from './objekt-rapport/objekt-rapport.component';
import {ObjectActivityType, ObjekteBaseComponent} from './objekte-base';
import MsgReader from '@kenjiuno/msgreader';
import {MailPreviewDialogComponent, MailPreviewDialogData} from 'src/app/swiss-forms/mail-preview-dialog/mail-preview-dialog.component';
import {decompressRTF} from '@kenjiuno/decompressrtf';
import iconv from 'iconv-lite';
import {deEncapsulateSync} from 'rtf-stream-parser';
import {DomSanitizer} from '@angular/platform-browser';

import {UserAuthenticationService} from 'src/app/services/user-authentication.service';
import {HelperService} from 'src/app/services/helper.service';
import {DeviceDetectionService} from '../../services/device-detection-service';
import {TreeNode, TreeviewService} from '../../services/treeview.service';
import {LocalStorageService} from '../../local-storage.service';
import {PDFViewerDialogComponent} from '../../pdfviewer/pdfviewerDialog.component';
import {BehaviorSubject, from, Observable, of, Subscription, throwError} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {ObjectListViewComponent} from './object-listview/object-listview.component';
import {BenutzerModels} from '../../models/benutzer-models';
import {SwissInternModels} from '../../models/swissintern-models';
import DokumentTyp = DokumentModels.DokumentTyp;
import DokumentSource = DokumentModels.DokumentSource;
import DokumentInfo = DokumentModels.DokumentInfo;
import DefaultWebUserConfig = BenutzerModels.DefaultWebUserConfig;
import TreeViewDisplaySettings = SwissInternModels.TreeViewDisplaySettings;
import DEFAULT_OBJECT_SEARCH_SETTINGS = SwissInternModels.DEFAULT_OBJECT_SEARCH_SETTINGS;

@Component({
    selector: 'app-objekte', templateUrl: './objekte.component.html', styleUrls: ['./objekte.component.scss'], providers: [SwissFieldControlService, ToolbarService, LinkService, ImageService, HtmlEditorService,],
})
export class ObjekteComponent extends ObjekteBaseComponent implements OnInit, OnDestroy {
    objekte: Array<MainDataModels.SearchFieldResponseObjekt> = []; // Leeres Objekte-Array erstellen (SearchFieldResponseObjekt[])
    treeViewItemsBottomUp: Array<TreeViewItemSmall> = [];
    treeViewItemsTopDown: Array<TreeViewItemSmall> = [];
    @ViewChild('objektForm') objektForm?: ElementRef<Form>;
    @ViewChild('objListView') objListView?: ListViewComponent;
    @Input() swissFields: SwissFieldBase<any>[] = [];

    mySwissFieldsObjectDetailLinks: SwissFieldBase<any>[] = [];
    mySwissFieldsObjectDetailRechts: SwissFieldBase<any>[] = [];
    mySwissFieldsObjectExtensionLinks: SwissFieldBase<any>[] = [];
    mySwissFieldsObjectExtensionRechts: SwissFieldBase<any>[] = [];
    allDynamicObjectFields?: SwissFieldBase<any>[] = [];

    @Input() isDialog: boolean;
    formGrp!: UntypedFormGroup;

    /* Datenstatus */
    objectDataLoaded = false;
    currObjektOfflineStatus?: ObjektModels.ObjektOfflineStatus;

    /* Objektbaum */
    selectedTreeViewItem = '';

    /* Objekt ListView */
    dataSourceObjListView: ObjektModels.ObjectListViewItem[] = [];
    fieldsObjView: FieldSettingsModel = {
        id: 'objectID', text: 'objectNumber', groupBy: 'objectTypeDesc',
    };

    manuDesc: UntypedFormControl;
    memo: UntypedFormControl;
    filteredDescriptions?: MainDataModels.SearchFieldResponseObjekt[];

    /* ObjektAdressen */
    dataSourceObjektAdressen: MatTableDataSource<ObjektModels.ObjektAdresse>;
    hasObjektPartner = 0; // 0: nein | 1: ja
    displayedObjAdrColumns: string[] = ['adrtyp', 'kombiname', 'street', 'plz', 'city', 'telefon', 'anrede', 'email', 'natel', 'menuOA',];
    selectedObjektAdressID = '';
    /* Objekt-Aktivitäten (Dokumente) */
    dataSourceObjektAktivitaeten: MatTableDataSource<ObjektModels.ObjektAktivitaetListElement>;
    hasObjektDokus = 0; // 0: nein | 1: ja
    displayedObjDokuColumns: string[] = ['doku_art', 'doku_bearbeitet', 'doku_desc', 'doku_name', 'doku_vorname', 'doku_ansprechname', 'doku_ansprechvorname', 'menuBild',];
    selectedObjektDocumentID = '';
    objektAktivitaeten: ObjektModels.ObjektAktivitaetListElement[] = [];
    // Panel-Header Grösse
    expandPanelHeaderExpandendHeight = '42px';
    expandPanelHeaderCollapsedHeight = '42px';
    /* Erweiterte Objektsuche (zusätzlicher Header mit Projektleiter etc. ) */
    public advancedObjSearch = false;
    public objektSearchView$: BehaviorSubject<number> = new BehaviorSubject(1); // 1 = Objektbaum | 2 = Objekte Einsatz- oder Aufgabenplanung | 3 = Erweiterte Suche
    /* vinavon Intern => nur für Swiss-Soft Mitarbeiter gedacht */
    public isVinaIntern = false;
    public rapportGenerationInProgress = false;
    @ViewChild('uploader') uploader?: ElementRef<HTMLInputElement>;
    @ViewChild('treeviewComponent') treeviewComponent?: ObjectListViewComponent;
    fileExsist = false;
    selectObjectEventEmitter: EventEmitter<string> = new EventEmitter<string>();
    selectObjectEventEmitter2: EventEmitter<string> = new EventEmitter<string>();
    /* RichtText Editor */
    public tools: object = {
        items: ['Undo', 'Redo', '|', 'Bold', 'Italic', 'Underline', 'StrikeThrough', '|', 'FontName', 'FontSize', 'FontColor', 'BackgroundColor', '|', 'SubScript', 'SuperScript', '|', 'LowerCase', 'UpperCase', '|', 'Formats', 'Alignments', '|', 'OrderedList', 'UnorderedList', '|', 'Indent', 'Outdent', '|', 'CreateLink', 'Image', '|', 'ClearFormat', 'Print', 'SourceCode', '|', 'FullScreen',],
    };
    public height = 200;
    public fieldTopDown: Object = {
        dataSource: this.treeViewItemsTopDown, id: 'id', parentID: 'pid', text: 'name', hasChildren: 'hasChild', expanded: 'expanded', imageUrl: 'imageURL',
    };
    public fieldBottomUp: Object = {
        dataSource: this.treeViewItemsBottomUp, id: 'id', parentID: 'pid', text: 'name', hasChildren: 'hasChild', expanded: 'expanded', imageUrl: 'imageURL',
    };
    public desktopCameraMode = true;

    public deleteNodeEventEmitter: EventEmitter<any> = new EventEmitter<any>();
    public addNodeEventEmitter: EventEmitter<{ node: TreeNode, parentObjID: string }> = new EventEmitter<{ node: TreeNode, parentObjID: string }>();

    protected treeViewDisplaySettings$: BehaviorSubject<TreeViewDisplaySettings> = new BehaviorSubject(DEFAULT_OBJECT_SEARCH_SETTINGS);
    protected sideViewWidthStyle = '300px';
    private currentSideViewWidth = 300;

    private sortTreeView = signal(true);
    private objektAdresseDialogInput?: ObjektModels.ObjektAdresseDialogInput;
    private sub?: Subscription = undefined;
    /* Objekt-Aktivitäten (Keine Dokumente) */
    private currTerminMitBenutzern?: MainDataModels.TerminMitBenutzer;
    private currAufgabeMitBenutzern?: MainDataModels.AufgabeMitBenutzer;
    private currNotizMitBenutzern?: MainDataModels.NotizMitBenutzer;
    /* PDF-Erzeugung */
    private swissAppConfig!: SwissAppConfigModels.SwissAppConfig;
    private formControlSub: Subscription[] = [];
    private lastObjectID = '';
    protected subPartialTree: Subscription = this.objectSelected$.pipe(
        takeUntilDestroyed(this.destroyRef),
        filter(() => this.partialTreeMode$.getValue()),
        filter((objectID) => !!objectID && objectID !== this.lastObjectID),
        tap((objectID) => this.lastObjectID = objectID),
        tap(async (objectID) => {
            try {
                const treeviewObjects = await this.treeViewCache.getSortedTreeBranchOfObject(objectID, this.sortTreeView());
                const headNodeID = treeviewObjects.objects && treeviewObjects.objects[0] ? treeviewObjects.objects[0].objectID ?? '' : '';
                if (headNodeID !== '' && headNodeID !== this.currentHeadNodeID) {
                    this.currentHeadNodeID = headNodeID;
                }
                this.treeData$.next(treeviewObjects);
                this.emitObjectSelected(objectID);
            } catch (ex: any) {
                if (ex.status === 500 && ex.error.type === 'TreeSortOrderException') {
                    const webConfig = await this.localStorageService.get('webuserconfig', 'SwissWebConfigDB', false, DefaultWebUserConfig());
                    webConfig.sortTreeView = false;
                    await this.localStorageService.add('webuserconfig', webConfig, 'SwissWebConfigDB');

                    await this.svcSwissSettings.reloadWebUserConfig();

                    this.lastObjectID = '';
                    this.emitObjectSelected(objectID);
                    await this.svcMessageBox.showErrorOK('MAIN_APP_DIALOG.ERROR_DIALOG.ERROR_SORTING_TREE.text', 'MAIN_APP_DIALOG.ERROR_DIALOG.ERROR_SORTING_TREE.title', [ex.error.error]);
                }
            }
        })).subscribe();

    constructor(private svcSwissSettings: SwissSettingsService,
                public treeViewCache: TreeviewService,
                private deviceDetectionService: DeviceDetectionService,
                public svcObjekte: ObjektDataService,
                public svcDokuData: DokumentDataService,
                private svcMainData: MainDataService,
                public svcMessageBox: MessageBoxService,
                public userAuthService: UserAuthenticationService,
                private homeLayoutComponent: HomeLayoutComponent,
                public dialog: MatDialog,
                private fb: UntypedFormBuilder,
                public _datumFormatPipe: DatumFormatPipe,
                public swissSettings: SwissSettingsService,
                private router: Router,
                private route: ActivatedRoute,
                private sanitizer: DomSanitizer,
                private dokumentService: DokumentDataService,
                public helperService: HelperService,
                private localStorageService: LocalStorageService) {
        super(svcObjekte, _datumFormatPipe, userAuthService, swissSettings, svcDokuData, svcMessageBox, helperService, treeViewCache);
        // Wurde der Browser aktualisiert?
        this.helperService.getPageRefreshURL().then(async (url) => {
            if (url !== 'internalRouting') {
                this.helperService.setPageRefreshURL('/objekte').then(() => {
                    if (this.userAuthService.getCurrentAuthenticatedUser() == undefined) {
                        this.router.navigate(['']);
                    }
                });
            }
        });

        this.desktopCameraMode = !this.deviceDetectionService.getDevice().device.type;
        this.currObjekt = ObjektModels.EmptyObjektElement();
        this.manuDesc = new UntypedFormControl();
        this.memo = new UntypedFormControl();
        this.isDialog = false;
        this.formGrp = this.fb.group({});
        this.formGrp.addControl('manuDesc', this.manuDesc);
        this.formGrp.addControl('memo', this.memo);

        this.dataSourceObjektAdressen = new MatTableDataSource<ObjektModels.ObjektAdresse>();
        this.dataSourceObjektAktivitaeten = new MatTableDataSource<ObjektModels.ObjektAktivitaetListElement>();
        this.initUserRights();

        this.treeviewCache.getTreeViewDataChanged().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(res => {
            this.dataSubject.next({data: res, online: true});
        });

        from(this.localStorageService.get('treeviewSettings', 'SwissWebConfigDB', false, {height: '40%', width: '30%', activeTouchBubble: true})).pipe(
            takeUntilDestroyed(),
            tap(treeViewSettings => {
                this.treeViewDisplaySettings$.next(treeViewSettings);
            })
        ).subscribe();

        this.treeViewDisplaySettings$.pipe(
            takeUntilDestroyed(),
            tap(async treeViewSettings => {
                this.sideViewWidthStyle = treeViewSettings.width;
                this.currentSideViewWidth = parseInt(treeViewSettings.width.replace('px', ''), 10);
                await this.localStorageService.add('treeviewSettings', treeViewSettings, 'SwissWebConfigDB');
            })
        ).subscribe();

        this.svcObjekte.registerObjActivitiesFunc(this.reloadObjektAktivitaeten.bind(this));
        this.svcObjekte.registerLoadSingleObject(this.loadObjectByObjectID.bind(this));
    }

    async refreshTreByOnlineStatus(): Promise<void> {
        this.partialTreeMode$.next(true);
        if (this.objektSearchView$.getValue() === 2 || this.objektSearchView$.getValue() === 3) {
            await this.loadObjektListView();
        } else {
            await this.refreshObjektBaum();
        }

        if (!this.helperService.isWebServiceAvailable()) {
            this.refreshOfflineSuchfeldBeschreibungen();
        } else {
            this.refreshSuchfeldBeschreibungen();

        }
    }

    ngOnInit(): void {
        let url = '/objekte';
        if (this.deviceDetectionService.getDevice().device.type == 'mobile') {
            url = '/objekte-mobile';
        }

        this.sub = this.route.params.subscribe({
            next: async (params: Params) => {
                if (params.id) {
                    this.svcObjekte.setCurrentObjectID(params.id);
                } else {
                    if (this.svcObjekte.getCurrentObjectID()) {
                        /// TODO set url without navigation
                        // await this.router.navigate([url, this.svcObjekte.getCurrentObjectID()]);
                    } else {
                        // await this.router.navigate([url]);
                    }
                }
            }
        });

        this.swissSettings.waitForSwissAppConfigs().then(async () => {
            this.swissAppConfig = this.swissSettings.getSwissAppConfig();
            this.isVinaIntern = this.swissAppConfig?.vinaIntern || false;

            this.swissSettings.getWebConfig$().pipe(
                takeUntilDestroyed(this.destroyRef),
                tap(conf => {
                    this.sortTreeView.set(!!conf.sortTreeView);
                })
            ).subscribe();

            if (this.isVinaIntern) {
                await this.svcObjekte.loadObjektRapportLogo();
            }
            this.objektSearchView$.next(this.swissSettings?.getObjViewConfig() || 1);
            this.advancedObjSearch = this.swissAppConfig?.advancedObjSearch || true;

            switch (this.objektSearchView$.getValue()) {
                case 1:
                    this.svcObjekte.loadObjektTypes().then((res) => {
                        if (res) {
                            // Anzeige mit Objektbaum
                            this.refreshObjektBaum().then((res) => {
                                if (res) {
                                    this.initData();
                                }
                            });
                        }
                    });
                    break;
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                    this.loadObjektListView();
                    break;
                case 7:
                    this.svcObjekte.loadObjektTypes().then((res) => {
                        this.treeViewCache.GetTreeDynamic(true).then(tree => {
                            this.treeData$.next(tree);
                        });
                    });
                    break;
                default:
                    throw new Error('Unknow ObjectView Configuration');
            }
        });
    }

    ngOnDestroy(): void {
        this.dataSubject2.unsubscribe();
        this.dataSubject.unsubscribe();
    }


    async onObjectSelectedByTree(objectId: string) {
        requestAnimationFrame(async () => {
            if (this.currObjekt.objectID != objectId) {
                this.lastObjectID = '';
                await this.loadObject(objectId);
            }
        });
    }

    async onObjectSelectedBySearch(objectID: string) {
        requestAnimationFrame(async () => {
            if (this.currObjekt.objectID != objectID) {
                await this.loadObject(objectID);
                if (this.partialTreeMode$.getValue()) {
                    this.objectSelected$.next(objectID);
                    return;
                }
            }

            this.emitObjectSelected(objectID);
        });
    }

    async loadObject(objectId: string) {
        return new Promise(resolve => {
            if (this.helperService.isWebServiceAvailable()) {
                this.svcObjekte.getObjektByID(objectId).subscribe({
                    next: (obj: ObjektModels.ObjektElement) => {
                        this.setObjekt(obj).then(() => {
                            resolve(true);
                        });
                    }, error: () => resolve(false),
                });
            } else {
                this.svcObjekte.getOfflineObjektByID(objectId).subscribe({
                    next: (obj: ObjektModels.ObjektElement) => {
                        this.setObjekt(obj).then(() => {
                            resolve(true);
                        });
                    }, error: () => resolve(false),
                });
            }
        });
    }

    async setObjekt(obj: ObjektModels.ObjektElement) {
        return new Promise(resolve => {
            this.svcObjekte.checkObjectPW(obj).then((val) => {
                // val ist true, wenn kein Kennwort vorhanden ist, oder das Passwort richtig eingegeben wurde
                if (val) {
                    this.currObjekt = obj;
                    this.svcObjekte.setCurrentObject(this.currObjekt);

                    this.setExpandStateObjektDetails(0); // Panel Objekt-Details öffnen

                    if (this.objektSearchView$.getValue() !== 1) {
                        this.setExpandStateObjektStruktur(0); // Panel Objekt-Struktur öffnen
                    }

                    // via Service den anderen Komponenten das Objekt mitteilen
                    this.loadObjektAdditionalData(true);
                    resolve(true);
                } else {
                    this.cleanObjectData();
                    resolve(false);
                }
            });
        });
    }

    async loadObjektAdditionalData(blShowObjektInTreeview: boolean) {
        this.allDynamicObjectFields = [];

        // Formularwerte neu setzen --> DataBinding
        await this.fillFormDataValues();
        // Objektadressen laden
        await this.reloadObjektAdressen();
        // Objekt-Aktivitäten (Dokumente) laden
        await this.reloadObjektAktivitaeten();

        // Berechtigungen anhand Betriebsteile (Companyparts ermitteln)
        // await this.reloadObjektBerechtigungen();
        if (blShowObjektInTreeview) {
            if (this.objektSearchView$.getValue() === 2 || this.objektSearchView$.getValue() === 3) {
                this.refreshObjektBaumBottomUp().then(async () => {
                    await this.refreshObjektBaumTopDown();
                });
            }
        }
    }

    async uploadFilePDF(event: any) {
        const info: DokumentModels.DokumentInfo = {
            objectID: this.svcObjekte.getCurrentObjectID(),
            documentID: uuidv4(),
            fileName: '',
            description: '',
            dokumentTyp: DokumentModels.DokumentTyp.Dokument,
            dokumentQuelle: DokumentModels.DokumentSource.ObjektNavi,
            lastModified: new Date()
        };
        let canceledUpload = false;
        await this.reloadObjektAktivitaeten();
        for (let i = 0; i < event.target.files.length; i++) {
            if (event.target.files.length > 1) {
                const name = this.addNumberToFile(event.target.files[i].name);
                info.objectID = this.svcObjekte.getCurrentObjectID();
                info.documentID = uuidv4();
                info.fileName = name;
                const fExt = name.lastIndexOf('.');
                info.description = name.substring(0, fExt);
                this.dokumentService.setDocumentInfo(info);
            } else {
                const dialogRef = this.svcMessageBox.showFileNameDialog(event.target.files[i].name);
                const data = (await dialogRef);
                if (!data.doSave) {
                    canceledUpload = true;
                }

                const name = this.addNumberToFile(data.value);
                info.objectID = this.svcObjekte.getCurrentObjectID();
                info.documentID = uuidv4();
                const fExt = name.lastIndexOf('.');
                info.description = name.substring(0, fExt);
                info.fileName = name;
                this.dokumentService.setDocumentInfo(info);
            }
            const splitName = info.fileName.split('.');
            if (['png', 'jpg', 'jpeg', 'bmp'].includes(splitName[splitName.length - 1].toLowerCase())) {
                info.dokumentTyp = DokumentTyp.Foto;
            }

            if (!canceledUpload) {
                this.dokumentService.uploadDokumentWithInfo(event.target.files[i], info).subscribe({
                    next: () => {
                        this.svcMessageBox.showSuccess('Das Dokument wurde erfolgreich gespeichert.', 'Erfolgreich');
                        this.reloadObjektAktivitaeten();
                    }, error: (err) => {
                        if (err.error.code == 'IllegalFileName') {
                            this.svcMessageBox.showErrorByLanguageKey('MAIN_APP_DIALOG.ERROR_DIALOG.ILLEGAL_FILENAME.text', 'MAIN_APP_DIALOG.ERROR_DIALOG.ILLEGAL_FILENAME.title');
                        } else {
                            this.svcMessageBox.showError('Das Dokument konnte nicht gespeichert werden!!', '!! FEHLER !!');
                        }
                    },
                });
            }
        }
        this.uploader!.nativeElement.value = '';
    }

    async openDocument(element: ObjektModels.ObjektAktivitaetListElement): Promise<void> {
        switch (element.art) {
            case ObjectActivityType.Aufgabe:
                this.editTask(element.id);
                break;
            case ObjectActivityType.Bild:
                this.showImage(element);
                break;
            case ObjectActivityType.Termin:
                this.editAppointment(element.id);
                break;
            case ObjectActivityType.Notiz:
                this.editNote(element.id);
                break;
            case ObjectActivityType.Notizblatt:
            case ObjectActivityType.ObjektReport:
            default:
                let fileName = element.documentName;
                let fileExtension = fileName.substring(fileName.lastIndexOf('.'));
                if (fileExtension.toLowerCase() === '.s3a') {
                    fileName = fileName.substring(0, fileName.lastIndexOf('.')) + '.pdf';
                    fileExtension = '.pdf';
                }
                switch (fileExtension.toLowerCase()) {
                    case '.pdf':
                        await this.openPDFViewer(element.id, fileName, element.description, undefined, undefined, undefined);
                        break;
                    case '.msg':
                        this.svcDokuData.getDocumentBlob(element.id).then(data => {
                            const dialogData: MailPreviewDialogData = {
                                isHTML: false, text: ''
                            };
                            data.arrayBuffer().then(buffer => {
                                const testMsg = new MsgReader(buffer);
                                const compressedRtf = testMsg.getFileData().compressedRtf;
                                if (compressedRtf) {
                                    const rtfBlob = decompressRTF(Array.from(compressedRtf));
                                    const stream = iconv.decode(Buffer.from(rtfBlob), 'latin1');
                                    const result = deEncapsulateSync(stream, {decode: iconv.decode});

                                    dialogData.isHTML = result.mode == 'html';
                                    dialogData.text = this.sanitizer.bypassSecurityTrustHtml(this.blankATags(result.text as string));
                                } else {
                                    if (testMsg.getFileData().bodyHtml) {
                                        dialogData.isHTML = true;
                                        dialogData.text = this.sanitizer.bypassSecurityTrustHtml(this.blankATags(testMsg.getFileData().bodyHtml ?? ''));
                                    }
                                }
                                this.dialog.open(MailPreviewDialogComponent, {
                                    data: dialogData
                                });
                            });
                        });
                        break;
                    default:
                        this.svcDokuData.downloadDocument(element.id, fileName);
                }
        }
    }

    downloadImage(element: ObjektModels.ObjektAktivitaetListElement) {
        const docID = element.id;
        const listEntry = this.objektAktivitaeten.find((doc) => doc.id === docID);

        if (this.helperService.isWebServiceAvailable() && listEntry) {
            this.svcDokuData.downloadDocument(docID, listEntry.documentName);
        } else {
            this.svcDokuData.openLocalDocument(docID);
        }
    }

    editAppointment(calendarID: string) {
        this.svcMainData.loadTerminByID(calendarID).subscribe({
            next: (res) => {
                const dialogRef = this.dialog.open(TerminEintragComponent, {
                    disableClose: true, data: res,
                });

                dialogRef.afterClosed().subscribe({
                    next: (result) => {
                        this.currTerminMitBenutzern = result;
                        if (this.currTerminMitBenutzern) {
                            // Update Informations
                            this.svcMainData
                                .saveTermin(this.currTerminMitBenutzern)
                                .subscribe({
                                    next: () => {
                                        this.svcMessageBox.showSuccess('Der Termin wurde erfolgreich aktualisiert.', 'Erfolgreich');
                                        this.svcMainData.reloadCalendarData();
                                        this.reloadObjektAktivitaeten();
                                    }, error: (error) => {
                                        console.error('editAppointment: ', error);
                                        this.svcMessageBox.showError('Der Termin konnte nicht angepasst werden!!', '!! FEHLER !!');
                                    },
                                });
                        }
                    },
                });
            },
        });
    }

    refreshObjektBaumBottomUp(): Promise<boolean> {
        return new Promise((resolve) => {
            this.treeViewItemsBottomUp = [];
            this.svcObjekte.getObjektBaumBottomUp(this.svcObjekte.getCurrentObjectID()).subscribe({
                next: (res) => {
                    this.treeViewItemsBottomUp = this.treeViewItemsBottomUp.concat(res);
                    this.fieldBottomUp = {
                        dataSource: this.treeViewItemsBottomUp, id: 'objectID', parentID: 'parentObject', text: 'name', hasChildren: 'hasChild', expanded: 'expanded', imageUrl: 'imageURL',
                    };
                    resolve(true);
                },
            });
        });
    }

    refreshObjektBaumTopDown(): Promise<boolean> {
        return new Promise((resolve) => {
            this.treeViewItemsTopDown = [];
            this.svcObjekte.getObjektBaumTopDown(this.svcObjekte.getCurrentObjectID()).subscribe({
                next: (res) => {
                    this.treeViewItemsTopDown = this.treeViewItemsTopDown.concat(res);
                    this.fieldTopDown = {
                        dataSource: this.treeViewItemsTopDown, id: 'objectID', parentID: 'parentObject', text: 'name', hasChildren: 'hasChild', expanded: 'expanded', imageUrl: 'imageURL',
                    };
                    resolve(true);
                },
            });
        });
    }

    removeSuchfeldBeschreibungen() {
        const index = this.objekte.findIndex((o) => o.objectID === this.svcObjekte.getCurrentObjectID());
        if (index > -1) {
            // Objekt aus Array löschen
            this.objekte.splice(index, 1);
        }
    }

    addAllFieldsToFormGroup(allDynFields: SwissFieldBase<any>[]) {
        allDynFields.forEach((formItem) => {
            const formControl = this.fb.control({value: formItem.options.value, disabled: formItem.options.readOnly}, formItem.options.required ? Validators.required : null);
            this.formGrp.addControl(formItem.options.key!, formControl);
        });
    }

    loadFormFields() {
        return new Promise(async (resolve) => {
            this.formGrp = this.fb.group({});
            this.formGrp.addControl('manuDesc', this.manuDesc, {emitEvent: false});
            this.formGrp.addControl('memo', this.memo, {emitEvent: false});

            const objType = Number.parseInt(this.currObjekt.objectType);
            this.svcObjekte.getFormFieldsFromLocalStorageIfExists(1, objType).then(o => o.subscribe({
                next: async (res: any[]) => {
                    if (res) {
                        this.svcObjekte.setOfflineFormFields(1, objType, res);
                        res.forEach((field: { isNewEntity: boolean }) => (field.isNewEntity = false));
                        // Alle Felder der Gruppe "Objektdetails" hinzufügen
                        this.addAllFieldsToFormGroup(res);
                        this.mySwissFieldsObjectDetailLinks = res.filter((f: { options: { location: number } }) => f.options.location === 1);
                        this.mySwissFieldsObjectDetailRechts = res.filter((f: { options: { location: number } }) => f.options.location === 2);

                        this.mySwissFieldsObjectDetailLinks = this.mySwissFieldsObjectDetailLinks!.sort((a, b) => a.options.order! - b.options.order!);
                        this.mySwissFieldsObjectDetailRechts = this.mySwissFieldsObjectDetailRechts!.sort((a, b) => a.options.order! - b.options.order!);

                        this.mySwissFieldsObjectDetailLinks.forEach((val) => this.allDynamicObjectFields?.push(Object.assign({}, val)));
                        this.mySwissFieldsObjectDetailRechts.forEach((val) => this.allDynamicObjectFields?.push(Object.assign({}, val)));

                        this.svcObjekte.getFormFieldsFromLocalStorageIfExists(2, objType).then(o2 => o2.subscribe({
                            next: async (res2: any[]) => {
                                if (res2) {
                                    // this.svcObjekte.setOfflineFormFields(2, objType, res2);
                                    res2.forEach((field) => (field.isNewEntity = false));
                                    // Alle Felder der Gruppe "Objekterweiterung" hinzufügen
                                    this.addAllFieldsToFormGroup(res2);
                                    this.mySwissFieldsObjectExtensionLinks = res2.filter((f) => f.options.location === 1);
                                    this.mySwissFieldsObjectExtensionRechts = res2.filter((f) => f.options.location === 2);

                                    this.mySwissFieldsObjectExtensionLinks = this.mySwissFieldsObjectExtensionLinks.sort((a, b) => a.options.order! - b.options.order!);
                                    this.mySwissFieldsObjectExtensionRechts = this.mySwissFieldsObjectExtensionRechts.sort((a, b) => a.options.order! - b.options.order!);

                                    this.mySwissFieldsObjectExtensionLinks.forEach((val) => this.allDynamicObjectFields?.push(Object.assign({}, val)));
                                    this.mySwissFieldsObjectExtensionRechts.forEach((val) => this.allDynamicObjectFields?.push(Object.assign({}, val)));
                                    resolve(new Response('Formfields loaded'));
                                }
                            }, error: (error: any) => console.error('Fehler bei der Ermittlung von Feldern (Objektdetails). ', error),
                        }));
                    }
                }, error: (error: any) => console.error('Fehler bei der Ermittlung von Feldern. (Objekterweiterung) ', error),
            }));
        });
    }

    loadOfflineFormFields() {
        return new Promise((resolve) => {
            this.svcObjekte.getOfflineFormFields(1, parseInt(this.currObjekt.objectType, 10)).then((res) => {
                if (res) {
                    res.forEach((field) => {
                        field.isNewEntity = false;
                        field.options.readOnly = true;
                    });
                    // Alle Felder der Gruppe "Objekterdetails" hinzufügen
                    this.addAllFieldsToFormGroup(res);
                    this.mySwissFieldsObjectDetailLinks = res.filter((f) => f.options.location === 1);
                    this.mySwissFieldsObjectDetailRechts = res.filter((f) => f.options.location === 2);

                    this.mySwissFieldsObjectDetailLinks = this.mySwissFieldsObjectDetailLinks.sort((a, b) => a.options.order! - b.options.order!);
                    this.mySwissFieldsObjectDetailRechts = this.mySwissFieldsObjectDetailRechts.sort((a, b) => a.options.order! - b.options.order!);

                    this.mySwissFieldsObjectDetailLinks.forEach((val) => this.allDynamicObjectFields?.push(Object.assign({}, val)));
                    this.mySwissFieldsObjectDetailRechts.forEach((val) => this.allDynamicObjectFields?.push(Object.assign({}, val)));

                    this.svcObjekte.getOfflineFormFields(2, parseInt(this.currObjekt.objectType, 10)).then((res2) => {
                        if (res2) {
                            res2.forEach((field) => {
                                field.isNewEntity = false;
                                field.options.readOnly = true;
                            });
                            // Alle Felder der Gruppe "Objekterweiterung" hinzufügen
                            this.addAllFieldsToFormGroup(res2);
                            this.mySwissFieldsObjectExtensionLinks = res2.filter((f) => f.options.location === 1);
                            this.mySwissFieldsObjectExtensionRechts = res2.filter((f) => f.options.location === 2);

                            this.mySwissFieldsObjectExtensionLinks = this.mySwissFieldsObjectExtensionLinks.sort((a, b) => a.options.order! - b.options.order!);
                            this.mySwissFieldsObjectExtensionRechts = this.mySwissFieldsObjectExtensionRechts.sort((a, b) => a.options.order! - b.options.order!);

                            this.mySwissFieldsObjectExtensionLinks.forEach((val) => this.allDynamicObjectFields?.push(Object.assign({}, val)));
                            this.mySwissFieldsObjectExtensionRechts.forEach((val) => this.allDynamicObjectFields?.push(Object.assign({}, val)));

                            resolve(true);
                        } else {
                            resolve(true);
                        }
                    });
                } else {
                    resolve(false);
                }
            });
        });
    }

    editNote(noteID: string) {
        this.svcMainData.loadNoteByID(noteID).subscribe({
            next: (res) => {
                const dialogRef = this.dialog.open(NotizEintragComponent, {
                    disableClose: true, data: res,
                });

                dialogRef.afterClosed().subscribe({
                    next: (result) => {
                        this.currNotizMitBenutzern = result;
                        if (this.currNotizMitBenutzern) {
                            // Update Information
                            this.svcMainData.saveNotiz(this.currNotizMitBenutzern).subscribe({
                                next: () => {
                                    this.svcMessageBox.showSuccess('Die Notiz wurde erfolgreich gespeichert.', 'Erfolgreich');
                                    this.reloadObjektAktivitaeten();
                                    this.svcMainData.refreshNoteCount();
                                }, error: (error) => {
                                    console.error(error);
                                    this.svcMessageBox.showError('Die Notiz konnte nicht gespeichert werden!!', '!! FEHLER !!');
                                },
                            });
                            if (this.swissSettings.getWebConfig().debugMode) {
                                console.log('Dialog Resultat (currNotizMitBenutzern): ', this.currNotizMitBenutzern);
                            }
                        }
                    },
                });
            },
        });
    }

    editTask(taskID: string) {
        this.svcMainData.loadTaskByID(taskID).subscribe({
            next: (res) => {
                const dialogRef = this.dialog.open(AufgabeEintragComponent, {
                    disableClose: true, data: res,
                });

                return dialogRef.afterClosed().subscribe({
                    next: (result) => {
                        if (result) {
                            this.currAufgabeMitBenutzern = result;
                            // Update Information
                            if (this.currAufgabeMitBenutzern) {
                                this.svcMainData.saveAufgabe(this.currAufgabeMitBenutzern).subscribe({
                                    next: () => {
                                        this.svcMessageBox.showSuccess('Die Aufgabe wurde erfolgreich gespeichert.', 'Erfolgreich');
                                        this.reloadObjektAktivitaeten();
                                    }, error: (error) => {
                                        console.error(error);
                                        this.svcMessageBox.showError('Die Aufgabe konnte nicht gespeichert werden!!', '!! FEHLER !!');
                                    },
                                });
                            }
                        }
                    },
                });
            },
        });
    }

    cleanObjectData() {
        this.currObjekt = ObjektModels.EmptyObjektElement();
        this.hasObjektDokus = 0;
        this.hasObjektPartner = 0;
        this.dataSourceObjektAdressen = new MatTableDataSource<ObjektModels.ObjektAdresse>();
        this.dataSourceObjektAktivitaeten = new MatTableDataSource<ObjektModels.ObjektAktivitaetListElement>();
        this.objectDataLoaded = false;
        this.selectedTreeViewItem = '';
        this.setExpandStateObjektDetails(1);
        this.setExpandStateObjektErweiterung(1);
        this.setExpandStateObjektAktivitaeten(1);
        this.setExpandStateObjektAdressen(1);
        this.setExpandStateObjektDokuInfos(1);
        this.setExpandStateObjektStruktur(1);
    }

    fillFormDataValuesByType(swissFields: SwissFieldBase<any>[]) {
        for (const swissField of swissFields) {
            // Aus DropDown-Feldern wird ein Textfeld gemacht... dann muss nicht die ID, sonder der Wert geladen werden.
            // Vor allem wichtig beim Objekt-Typen
            if (swissField.controlType === 'dropdown') {
                if (swissField.options.readOnly) {
                    if (swissField.options.optionsBestehend) {
                        const value = this.currObjekt[swissField.options.dataBinding as keyof ObjektModels.ObjektElement];
                        const findValue = swissField.options.optionsBestehend.filter((x) => x.key == value)[0];
                        swissField.options.value = findValue ? findValue.value : '';
                    }
                } else {
                    const value = this.currObjekt[swissField.options.dataBinding as keyof ObjektModels.ObjektElement];
                    if (value) {
                        swissField.options.value = String(value);
                    }
                }
            } else if (swissField.controlType === 'date_with_time') {
                const dateString = this.currObjekt[swissField.options.dataBinding as keyof ObjektModels.ObjektElement];
                if (dateString) {
                    swissField.options.value = this.formatDate(new Date(String(dateString)));
                }
            } else {
                swissField.options.value = this.currObjekt[swissField.options.dataBinding as keyof ObjektModels.ObjektElement];
            }
        }
        // Array kopieren
        swissFields.forEach((val) => this.allDynamicObjectFields?.push(Object.assign({}, val)));
    }

    addNumberToFile(fileName: string): string {
        const fileExtension = fileName.slice(fileName.lastIndexOf('.'));
        const baseName = fileName.slice(0, fileName.lastIndexOf('.'));
        let newName = fileName;
        let counter = 0;
        while (!this.isUniqueName(newName, this.dataSourceObjektAktivitaeten.filteredData)) {
            counter++;
            newName = `${baseName}_${counter}${fileExtension}`;
        }
        return newName;
    }

    isUniqueName(name: string, dataSource) {
        return dataSource.findIndex((result) => result.documentName == name) == -1;
    }

    setFieldUserRights() {
        if (!this.rechtObjektMutieren) {
            this.formGrp.disable();
        } else {
            // Auf Änderungen reagieren, wenn es kein neues Objekt ist (Auftrag / ProdAuftrag)
            this.formControlSub.forEach(sub => sub.unsubscribe());
            this.formControlSub = Object.keys(this.formGrp.controls).map((key) => {
                if (key !== 'manuDesc' && key !== 'memo') {
                    return this.formGrp.get(key)?.valueChanges.pipe(debounceTime(300), concatMap(() => this.onSubmit(key))).subscribe();
                }
                return undefined;
            }).filter(a => a != null);
        }
    }

    blankATags(htmlString: string) {
        const div = document.createElement('div');
        div.innerHTML = htmlString.trim();
        Array.from(div.getElementsByTagName('a')).forEach(element => {
            element.target = '_blank';
        });
        return div.innerHTML;
    }

    fillFormDataValues(): Promise<boolean> {
        return new Promise((resolve) => {
            let f: Function;
            if (this.helperService.isWebServiceAvailable()) {
                f = this.loadFormFields;
            } else {
                f = this.loadOfflineFormFields;
            }

            f.call(this).then(() => {
                this.allDynamicObjectFields = [];

                if (this.mySwissFieldsObjectDetailLinks) {
                    this.fillFormDataValuesByType(this.mySwissFieldsObjectDetailLinks);
                }

                if (this.mySwissFieldsObjectDetailRechts) {
                    this.fillFormDataValuesByType(this.mySwissFieldsObjectDetailRechts);
                }

                if (this.mySwissFieldsObjectExtensionLinks) {
                    this.fillFormDataValuesByType(this.mySwissFieldsObjectExtensionLinks);
                }

                if (this.mySwissFieldsObjectExtensionRechts) {
                    this.fillFormDataValuesByType(this.mySwissFieldsObjectExtensionRechts);
                }

                // Geladene Daten dem Form hinzufügen
                this.resetFormGroup();

                // Berechtigungen und Event-Handling setzen
                this.setFieldUserRights();
                this.objectDataLoaded = true;

                resolve(true);
            });
        });
    }

    onDelObjekt() {
        if (this.currObjekt.objectID != '') {
            this.svcObjekte
                .checkObjectDeleteRequest(this.currObjekt.objectID)
                .subscribe({
                    next: (res: ObjektModels.ObjektReferenzInfos) => {
                        const objRefInfos: ObjektModels.ObjektReferenzInfos = res;

                        if (objRefInfos.hatUnterobjekte === 1) {
                            this.svcMessageBox.showInfo('Das Objekt hat untergeordnete Objekte und kann nicht gelöscht werden.', 'Löschen nicht möglich');
                        } else if (objRefInfos.anzDokumente > 0 || objRefInfos.anzAufgaben > 0 || objRefInfos.anzNotizen > 0 || objRefInfos.anzTermine > 0 || objRefInfos.anzZeitkontrolle > 0 || objRefInfos.anzAuslastungsplanung > 0 || objRefInfos.anzEinsatzplanung > 0) {
                            // Frage generieren
                            const ausgabeListe: string[] = [];
                            if (objRefInfos.anzDokumente > 0) {
                                ausgabeListe.push('Anzahl Dokumente: ' + objRefInfos.anzDokumente);
                            }
                            if (objRefInfos.anzAufgaben > 0) {
                                ausgabeListe.push('Anzahl Aufgaben: ' + objRefInfos.anzAufgaben);
                            }
                            if (objRefInfos.anzNotizen > 0) {
                                ausgabeListe.push('Anzahl Notizen: ' + objRefInfos.anzNotizen);
                            }
                            if (objRefInfos.anzTermine > 0) {
                                ausgabeListe.push('Anzahl Termine: ' + objRefInfos.anzTermine);
                            }
                            if (objRefInfos.anzZeitkontrolle > 0) {
                                ausgabeListe.push('Anzahl Einträge in Zeitkontrolle: ' + objRefInfos.anzZeitkontrolle);
                            }
                            if (objRefInfos.anzAuslastungsplanung > 0) {
                                ausgabeListe.push('Anzahl Einträge in Auslastungsplanung: ' + objRefInfos.anzAuslastungsplanung);
                            }
                            if (objRefInfos.anzEinsatzplanung > 0) {
                                ausgabeListe.push('Anzahl Einträge in Einsatzplanung: ' + objRefInfos.anzEinsatzplanung);
                            }
                            if (objRefInfos.anzWL > 0) {
                                this.svcMessageBox.showErrorOK('MAIN_APP_DIALOG.DEL_OBJ_REF_WL.msg', 'MAIN_APP_DIALOG.DEL_OBJ_REF_WL.title', [], [this.currObjekt.objectNumber, this.currObjekt.description]);
                                return;
                            }

                            this.svcMessageBox
                                .askYesNoQuestionWithList('MAIN_APP_DIALOG.DEL_OBJ_REF.msg', 'MAIN_APP_DIALOG.DEL_OBJ_REF.title', ausgabeListe, [this.currObjekt.objectNumber, this.currObjekt.description])
                                .then((value) => {
                                    if (value) {
                                        this.delObjekt();
                                    }
                                });
                        } else {
                            this.svcMessageBox
                                .askYesNoQuestion('MAIN_APP_DIALOG.DEL_OBJ.msg', 'MAIN_APP_DIALOG.DEL_OBJ.title', [this.currObjekt.objectNumber, this.currObjekt.description])
                                .then((value) => {
                                    if (value) {
                                        this.delObjekt();
                                    }
                                });
                        }
                    }, error: (err: any) => {
                        console.error('checkObjectDeleteRequest - Fehler', err);
                        this.svcMessageBox.showError('Die Objektreferenzen für das Löschen des Objekts konnten nicht ermittelt werden!!', '!! FEHLER !!');
                    }
                });
        }
    }

    objDetailsTabChange(event: MatTabChangeEvent) {
        if (event.index === 1) {
            this.rteObj1?.refreshUI();
        } else if (event.index === 2) {
            this.rteObj2?.refreshUI();
        }
    }

    onNewObjekt() {
        this.onNewBaseObjekt();
        this.svcObjekte.createObjectDialog({parentObjectID: null}).then((res: ObjektModels.ObjektElement | boolean | string) => {
            this.onObjektCreated(res);
        });
    }

    saveFormValuesToObject(object: ObjektModels.ObjektElement, mySwissFields?: SwissFieldBase<any>[]) {
        if (mySwissFields) {
            for (const swissField of mySwissFields) {
                const value = this.formGrp.value[swissField.options.key as keyof ObjektModels.ObjektElement];

                // TODO if value == description update treeview node

                if (value != undefined && swissField.options.dataBinding) {
                    if (swissField.controlType === 'date_with_time') {
                        const datumMitZeit = value.substring(6, 4) + '-' + value.substring(3, 2) + '-' + value.substring(0, 2) + 'T' + value.substring(11, 8);

                        (object as any)[swissField.options.dataBinding as keyof ObjektModels.ObjektElement] = new Date(datumMitZeit);
                    } else {
                        (object as any)[swissField.options.dataBinding as keyof ObjektModels.ObjektElement] = value;
                    }
                }
            }
        }
    }

    onNewAuftrag() {
        this.onNewBaseObjekt();
        this.svcObjekte.createObjectDialog({parentObjectID: null, objectType: '2'}).then((res) => {
            this.onObjektCreated(res);
        });
    }

    onNewProdAuftrag() {
        this.onNewBaseObjekt();
        this.svcObjekte.createObjectDialog({parentObjectID: this.svcObjekte.getCurrentObjectID(), objectType: '4'})
            .then((res) => {
                this.onObjektCreated(res);
            });
    }

    saveDefaultFormValuesToObject(object: ObjektModels.ObjektElement) {
        if (this.formGrp.contains('manuDesc')) {
            const value = this.formGrp.value['manuDesc' as keyof ObjektModels.ObjektElement];
            if (value) {
                object.manufacturingDescription = value;
            }
        }

        // Notizen
        if (this.formGrp.contains('memo')) {
            const value = this.formGrp.value['memo' as keyof ObjektModels.ObjektElement];
            if (value) {
                object.memo = value;
            }
        }
    }

    searchObjNotFound(objectID: string) {
        if (!this.partialTreeMode$.getValue()) {
            if (!this.awaitingAnswer) {
                this.awaitingAnswer = true;
                this.svcMessageBox.askYesNoQuestion('MAIN_APP_DIALOG.TREEVIEW_OLD.msg', 'MAIN_APP_DIALOG.TREEVIEW_OLD.title').then(async res => {
                    this.awaitingAnswer = false;
                    if (res) {
                        await this.treeviewCache.updateData();
                        await this.refreshObjektBaum();
                    }
                });
            }
        } else {
            this.objectSelected$.next(objectID);
        }
    }

    async makeItOffline() {
        // Hier wird das bestehende Objekt-Offline verfügbar gemacht.
        if (this.currObjekt && this.currObjekt.objectID != '') {
            this.svcMessageBox.startWaitingDialog('MAIN_APP_DIALOG.WAIT_DIALOG.MAKE_OFFLINE.text', 'MAIN_APP_DIALOG.WAIT_DIALOG.MAKE_OFFLINE.title');
            let hasError = false;
            if (!(await this.svcObjekte.saveObjectInDB(this.currObjekt.objectID))) {
                hasError = true;
            }
            if (this.objektSearchView$.getValue() != 2) {
                if (hasError || !(await this.svcObjekte.saveSubObjectsInDB(this.currObjekt.objectID))) {
                    hasError = true;
                }
            }
            if (hasError || !(await this.svcObjekte.saveObjectAdressZuordInDB(this.currObjekt.objectID))) {
                hasError = true;
            }
            if (hasError || !(await this.svcObjekte.saveObjectAdressInDB(this.currObjekt.objectID))) {
                hasError = true;
            }
            if (hasError || !(await this.svcDokuData.saveObjectActivitiesInDB(this.currObjekt.objectID))) {
                hasError = true;
            }

            if (!hasError) {
                this.currObjektOfflineStatus = await this.svcObjekte.saveOfflineState(this.currObjekt.objectID);
                this.svcMessageBox.showSuccess('Das Objekt ist nun Offline verfügbar. ', 'Erfolgreich');
            } else {
                this.svcMessageBox.showError('Das Objekt konnte nicht gespeichert werden', '!!Fehler!!');
            }
            this.svcMessageBox.stopWaitingDialog();
        }
    }

    async refreshOfflineObjektBaum(): Promise<boolean> {
        const res = await this.svcObjekte.getOfflineObjektBaum();
        switch (this.objektSearchView$.getValue()) {
            case 1:
            case 2:
            case 3:
            case 4:
                if (!this.dataSubject.closed) {
                    this.dataSubject.next({data: res, online: false});
                }
                break;
            case 5:
            case 6:

                if (!this.dataSubject2.closed) {
                    this.dataSubject2.next({data: res, online: false});
                }
                break;
        }
        return true;
    }

    addObjectAddress() {
        this.objektAdresseDialogInput = {
            objektAdresseZuord: {
                id: '00000000-0000-0000-0000-000000000000', objectID: this.svcObjekte.getCurrentObjectID(), addressType: 5, // Diverses
                addressContact: 0, adressNumber: 0, adressID: '',
            }, blDoCheckUnique: true, blDisableAdrTypeSelect: false,
        };

        const dialogRef = this.dialog.open(ObjektAdresseComponent, {
            disableClose: true, width: '95%', maxHeight: '90vh', data: this.objektAdresseDialogInput,
        });

        dialogRef.afterClosed().subscribe({
            next: (result) => {
                if (result) {
                    this.objektAdresseDialogInput!.objektAdresseZuord = result;
                    if (this.objektAdresseDialogInput!.objektAdresseZuord) {
                        this.svcObjekte
                            .addObjectAddress(this.objektAdresseDialogInput!.objektAdresseZuord)
                            .subscribe({
                                next: async () => {
                                    await this.reloadObjektAdressen();
                                }, error: (err) => {
                                    console.error('Fehler: ', err);
                                    this.svcMessageBox.showError('Die Objektadresse konnte nicht gespeichert werden!!', '!! FEHLER !!');
                                }
                            });
                    }
                }
            },
        });
    }

    delContactPersonLink(element: ObjektModels.ObjektAdresse) {
        let fullName: string;
        if (element.firstName) {
            fullName = element.firstName + ' ' + element.lastName;
        } else {
            fullName = element.lastName;
        }

        this.svcMessageBox
            .askYesNoQuestion('MAIN_APP_DIALOG.DEL_ADDRESS_REF.msg', 'MAIN_APP_DIALOG.DEL_ADDRESS_REF.title', [fullName])
            .then((value) => {
                if (value) {
                    this.svcObjekte.delObjectAddress(element.id).subscribe({
                        next: () => {
                            this.reloadObjektAdressen();
                        }, error: (err) => {
                            console.error('Die Objektadresse konnte nicht entfernt werden. Fehler! ', err);
                            this.svcMessageBox.showError('Die Objektadresse konnte nicht entfernt werden!!', '!! FEHLER !!');
                        }
                    });
                }
            });
    }

    changeContactPerson(element: ObjektModels.ObjektAdresse) {
        this.objektAdresseDialogInput = {
            objektAdresseZuord: {
                id: element.id, objectID: this.svcObjekte.getCurrentObjectID(), addressType: element.addressType, addressContact: 0, adressNumber: 0, adressID: element.adressID, contactID: element.contactID,
            }, blDoCheckUnique: true, blDisableAdrTypeSelect: false,
        };

        const dialogRef = this.dialog.open(ObjektAdresseComponent, {
            disableClose: true, width: '95%', data: this.objektAdresseDialogInput,
        });
        dialogRef.afterClosed().subscribe({
            next: (result) => {
                if (result) {
                    this.objektAdresseDialogInput!.objektAdresseZuord = result;
                    if (this.objektAdresseDialogInput!.objektAdresseZuord) {
                        this.svcObjekte
                            .addObjectAddress(this.objektAdresseDialogInput!.objektAdresseZuord)
                            .subscribe({
                                next: async () => {
                                    await this.reloadObjektAdressen();
                                }, error: (err) => {
                                    console.error('objekte.componnent.ts:changeContactPerson(): Fehler: ', err);
                                    this.svcMessageBox.showError('Die Objektadresse konnte nicht entfernt werden!!', '!! FEHLER !!');
                                }
                            });
                    }
                }
            },
        });
    }

    copyAddressesOnSubObjects(element: ObjektModels.ObjektAdresse) {
        let fullName: string;
        if (element.firstName) {
            fullName = element.firstName + ' ' + element.lastName;
        } else {
            fullName = element.lastName;
        }

        this.svcMessageBox
            .askYesNoQuestion('MAIN_APP_DIALOG.COPY_ADDRESS_REF.msg', 'MAIN_APP_DIALOG.COPY_ADDRESS_REF.title', [fullName])
            .then((value) => {
                if (value) {
                    this.svcObjekte.copyObjectAddressTopDown(element.id).subscribe({
                        next: () => {
                        }, error: (err) => {
                            console.error('Fehler beim Kopieren der Adresszuordnungen auf die Unterobjekte', err);
                            this.svcMessageBox.showError('Fehler beim Kopieren der Adresszuordnungen auf die Unterobjekte', '!! FEHLER !!');
                        },
                    });
                }
            });
    }

    showImage(element: ObjektModels.ObjektAktivitaetListElement) {
        this.svcDokuData
            .getOtherDokumentFile(element.id, element.documentName)
            .then((value) => {
                if (value) {
                    const dokument: DokumentModels.DokumentBild = {
                        objectID: element.objectID, documentID: element.id, fileName: element.documentName, binary: value, doEdit: false,
                    };

                    this.dialog.open(ImageEditorComponent, {
                        disableClose: true, width: '800px', data: dokument,
                    });
                }
            });
    }

    getImage() {
        const dialogRef = this.dialog.open(CameraViewerComponent, {
            disableClose: true, width: '850px', panelClass: 'webcam-dialog-container',
        });

        dialogRef.afterClosed().subscribe({
            next: (result) => {
                if (result) {
                    const fileName: string = result.imageName + '.jpeg';
                    const file = new File([result.imageBlob], 'fileName');

                    const dokuInfo: DokumentModels.DokumentBild = {
                        objectID: this.svcObjekte.getCurrentObjectID(), documentID: uuidv4(), fileName, binary: file, doEdit: false,
                    };

                    // Speichert das Bild in der IndexedDB und sendet es an den Webservice
                    this.svcDokuData.uploadBild(dokuInfo).subscribe({
                        next: (res) => {
                            this.svcMessageBox.showSuccess('Das Kamera-Bild wurde erfolgreich gespeichert.', 'Erfolgreich');
                            this.reloadObjektAktivitaeten();
                        }, error: (err) => {
                            if (err.error.code == 'IllegalFileName') {
                                this.svcMessageBox.showErrorByLanguageKey('MAIN_APP_DIALOG.ERROR_DIALOG.ILLEGAL_FILENAME.text', 'MAIN_APP_DIALOG.ERROR_DIALOG.ILLEGAL_FILENAME.title');
                            } else {
                                this.svcMessageBox.showError('Das Bild konnte nicht gespeichert werden!!', '!! FEHLER !!');
                            }
                        }
                    });
                }
            },
        });
    }

    async saveImage(event: any, input: any) {
        const files = event.target.files;
        const fileSplitArr: string = files[0].name.split('.');
        await this.reloadObjektAktivitaeten();
        const fileName: string = this.addNumberToFile(this.currObjekt.objectNumber.trim() + '.' + fileSplitArr[fileSplitArr.length - 1]);

        const file = new File([new Blob([files[0]], {type: files[0].type})], 'fileName');

        const dokuInfo: DokumentModels.DokumentBild = {
            objectID: this.svcObjekte.getCurrentObjectID(), documentID: uuidv4(), fileName, binary: file, doEdit: false,
        };

        // Speichert das Bild in der IndexedDB und sendet es an den Webservice
        this.svcDokuData.uploadBild(dokuInfo).subscribe({
            next: async (res) => {
                this.svcMessageBox.showSuccess('Das Bild wurde erfolgreich gespeichert.', 'Erfolgreich');
                input.value = '';
                await this.reloadObjektAktivitaeten();
            }, error: (err) => {
                if (err.error.code == 'IllegalFileName') {
                    this.svcMessageBox.showErrorByLanguageKey('MAIN_APP_DIALOG.ERROR_DIALOG.ILLEGAL_FILENAME.text', 'MAIN_APP_DIALOG.ERROR_DIALOG.ILLEGAL_FILENAME.title');
                } else {
                    this.svcMessageBox.showError('Das Bild konnte nicht gespeichert werden!!', '!! FEHLER !!');
                }
            }
        });
    }

    async onNewPencilNote(): Promise<void> {
        const fieldInput = await this.svcMessageBox.showInputDialog<string>('MAIN_APP_DIALOG.INPUT_DIALOG.NEW_NOTE.title', 'MAIN_APP_DIALOG.INPUT_DIALOG.NEW_NOTE.label', 'Notizblatt');
        if (fieldInput.doSave) {
            await this.reloadObjektAktivitaeten();

            const fileName = this.addNumberToFile(fieldInput.value + '.pdf');
            const description = fileName.slice(0, fileName.lastIndexOf('.'));

            const binaryPDF = new Blob([new jsPDF('p', 'pt', 'a4').output('blob')], {
                type: 'application/pdf',
            });

            const id = uuidv4();
            const res = await this.svcDokuData.saveNotizblatt(id, this.svcObjekte.getCurrentObjectID(), description, fileName, binaryPDF, this.hasObjektDokus);
            await this.openPDFViewer(res.documentID, fileName, description, res.dokumentTyp, res.dokumentQuelle, res.lastModified);
        }
    }

    getOfflineState(): string {
        if (this.currObjektOfflineStatus) {
            return this.formatDate(this.currObjektOfflineStatus.abzugDatum);
        }
        return '';
    }

    editImage(element: ObjektModels.ObjektAktivitaetListElement) {
        this.svcDokuData
            .getOtherDokumentFile(element.id, element.documentName)
            .then((value) => {
                if (value) {
                    const dokument: DokumentModels.DokumentBild = {
                        objectID: element.objectID, documentID: element.id, fileName: element.documentName, binary: value, doEdit: true,
                    };

                    const dialogRef = this.dialog.open(ImageEditorComponent, {
                        disableClose: true, width: '800px', data: dokument,
                    });

                    dialogRef.afterClosed().subscribe({
                        next: async () => {
                            await this.reloadObjektAktivitaeten();
                        },
                    });
                }
            });
    }

    delImage(element: ObjektModels.ObjektAktivitaetListElement) {
        this.svcMessageBox
            .askYesNoQuestion('MAIN_APP_DIALOG.DEL_IMG.msg', 'MAIN_APP_DIALOG.DEL_IMG.title', [element.documentName])
            .then((value) => {
                if (value) {
                    this.svcObjekte
                        .deleteObjektAktivitaet(this.svcObjekte.getCurrentObjectID(), element.id, element.art)
                        .subscribe({
                            next: async (res) => {
                                if (res) {
                                    await this.reloadObjektAktivitaeten();
                                }
                            }, error: () => {
                                console.error('Fehler beim Löschen des Bildes!');
                                this.svcMessageBox.showError('Das Bild konnte nicht gelöscht werden. ', '!! FEHLER !!');
                            }
                        });
                }
            });
    }

    delActivity(element: ObjektModels.ObjektAktivitaetListElement) {
        this.svcMessageBox
            .askYesNoQuestion('MAIN_APP_DIALOG.DEL_OBJ_ACTIVITY.msg', 'MAIN_APP_DIALOG.DEL_OBJ_ACTIVITY.title')
            .then((value) => {
                if (value) {
                    if (element.art == 18) {
                        // Objekt-Report in der Indexed-DB löschen
                        this.svcObjekte.delLocalObjektReport(element.id);
                    } else {
                        // Notiz in der Indexed-DB löschen
                        this.svcDokuData.delLocalNotizblatt(element.id);
                    }

                    // Notiz / Objekt-Report via Webservice löschen
                    this.svcObjekte
                        .deleteObjektAktivitaet(this.svcObjekte.getCurrentObjectID(), element.id, element.art)
                        .subscribe({
                            next: (res) => {
                                if (res) {
                                    this.reloadObjektAktivitaeten();
                                }
                            }, error: () => {
                                console.error('Fehler beim Löschen einer Objektaktivität');
                                this.svcMessageBox.showError('Die Objektaktivität konnte nicht gelöscht werden. ', '!! FEHLER !!');
                            }
                        });
                }
            });
    }

    // um einen entsprechenden Rapport zu machen.
    addSwissSoftRapport() {
        if (this.svcObjekte.getCurrentObjectID()) {
            const pdfList = this.dataSourceObjektAktivitaeten.data.filter(activity => activity.imageFile === 'pdf.png').flatMap<DokumentInfo>(pdfActivity => {
                return {
                    objectID: pdfActivity.objectID,
                    documentID: pdfActivity.id,
                    description: pdfActivity.description,
                    fileName: pdfActivity.documentName,
                    dokumentTyp: DokumentTyp.Notizblatt,
                    dokumentQuelle: DokumentSource.FromWebService,
                    lastModified: new Date()
                };
            });
            const data = {
                objectID: this.svcObjekte.getCurrentObjectID(),
                mitarbeiter: this.userAuthService.getCurrentAuthenticatedUser()?.lastName || '',
                pdfList
            };

            this.dialog.open(ObjektRapportComponent, {
                disableClose: true, width: 'calc(100% - 50px)', maxWidth: '98vw', maxHeight: '90vh', data, panelClass: 'swissdefault-dialog-container',
            });
        }
    }

    // über eine Vorlage aufzunehmen
    async makeObjektRapport() {
        if (this.rapportGenerationInProgress) {
            return;
        }
        this.rapportGenerationInProgress = true;

        const objReportUploadElement = await this.svcObjekte.saveObjektReport(this.svcObjekte.getCurrentObjectID());
        if (objReportUploadElement) {
            await this.reloadObjektAktivitaeten();
            // PDF-Viewer mit Dokumenten-Informationen vorinformieren

            const name = this.addNumberToFile(objReportUploadElement.fileName);
            const fExt = name.lastIndexOf('.');

            const dokuInfo = this.svcDokuData.getDocumentInfo();

            // Dokument versuchen zu übermitteln
            const file = new File([objReportUploadElement.binary], objReportUploadElement.fileName, {
                type: 'application/pdf',
            });
            this.svcDokuData.uploadDokumentWithInfo(file, dokuInfo).subscribe({
                next: async (res) => {
                    this.svcMessageBox.showSuccess('Das Dokument wurde erfolgreich gespeichert.', 'Erfolgreich');
                    this.rapportGenerationInProgress = false;
                    // PDF-Viewer öffnen
                    await this.openPDFViewer(res.value, res.fileName, 'ObjektRapport', DokumentTyp.ObjektRapport, DokumentSource.ObjektRapport, new Date(res.timestamp));
                }, error: async (err) => {
                    this.rapportGenerationInProgress = false;
                    if (err.error.code === 'IllegalFileName') {
                        this.svcMessageBox.showErrorByLanguageKey('MAIN_APP_DIALOG.ERROR_DIALOG.ILLEGAL_FILENAME.text', 'MAIN_APP_DIALOG.ERROR_DIALOG.ILLEGAL_FILENAME.title');
                    } else {
                        this.svcMessageBox.showError('Das Dokument konnte nicht gespeichert werden!!', '!! FEHLER !!');
                        // PDF-Viewer öffnen
                        await this.openPDFViewer(objReportUploadElement.documentID, objReportUploadElement.fileName, 'ObjektRapport');
                    }
                },
            });
        } else {
            this.rapportGenerationInProgress = false;
        }
    }

    rteActionBegin(event: any) {
        if (event.requestType === 'Maximize') {
            this.homeLayoutComponent.closeMenu();
        }
        if (event.requestType === 'Minimize') {
            this.homeLayoutComponent.openMenu();
        }
    }

    rteContentChange(event: any, formControlName: string) {
        this.formGrp.controls[formControlName].patchValue(event.value);
        this.onSubmit(formControlName).subscribe();
    }

    /* Ende RichtText Editor */
    listViewItemClicked(event: any) {
        if (this.helperService.isWebServiceAvailable()) {
            this.svcObjekte.getObjektByID(event.data.objectID).subscribe({
                next: (obj) => {
                    this.svcObjekte.setCurrentObject(obj);
                    this.loadSingleObjekt(true);
                }
            });
        } else {
            this.svcObjekte.getOfflineObjektByID(event.data.objectID).subscribe({
                next: (obj) => {
                    this.svcObjekte.setCurrentObject(obj);
                    this.loadSingleObjekt(true);
                }
            });
        }
    }

    navigateToAddress(element) {
        this.router.navigate(['adressen', element.adressID]);
    }

    openCameraDialog() {
        if ('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices) {
            const dialog = this.dialog.open(CameraViewerComponent, {
                maxWidth: '100vw', maxHeight: '100vh', data: {isDialogMode: false}
            });
            dialog.afterClosed().subscribe({
                next: async (data) => {
                    if (data) {
                        await this.reloadObjektAktivitaeten();
                        const name = this.addNumberToFile(data.imageName);
                        const dokuInfo: DokumentModels.DokumentBild = {
                            objectID: this.svcObjekte.getCurrentObjectID(), documentID: uuidv4(), fileName: name, binary: data.imageBlob, doEdit: false,
                        };

                        // Speichert das Bild in der IndexedDB und sendet es an den Webservice
                        this.svcDokuData.uploadBild(dokuInfo).subscribe({
                            next: async () => {
                                this.svcMessageBox.showSuccess('Das Bild wurde erfolgreich gespeichert.', 'Erfolgreich');
                                await this.reloadObjektAktivitaeten();
                            }, error: (err) => {
                                if (err.error.code == 'IllegalFileName') {
                                    this.svcMessageBox.showErrorByLanguageKey('MAIN_APP_DIALOG.ERROR_DIALOG.ILLEGAL_FILENAME.text', 'MAIN_APP_DIALOG.ERROR_DIALOG.ILLEGAL_FILENAME.title');
                                } else {
                                    this.svcMessageBox.showError('Das Bild konnte nicht gespeichert werden!!', '!! FEHLER !!');
                                }
                            }
                        });
                    }
                }
            });
        } else {
            this.svcMessageBox.showError('Keine Kamera Verfügbar', '!!Fehler!!');
        }
    }

    public changePosition(event: any) {
        this.sideViewWidthStyle = this.currentSideViewWidth + event.deltaX + 'px';
    }

    public async panEnd(): Promise<void> {
        this.currentSideViewWidth = Number.parseInt(this.sideViewWidthStyle.slice(0, -2), 10);
        const treeViewDisplaySettings = this.treeViewDisplaySettings$.getValue();
        treeViewDisplaySettings.width = this.currentSideViewWidth + 'px';
        this.treeViewDisplaySettings$.next(treeViewDisplaySettings);
    }

    protected onSubmit(updateFieldKey: string): Observable<any> {
        if (!this.helperService.isWebServiceAvailable()) {
            return of();
        }

        // Neues oder bestehendes Objekt wird gespeichert
        const objectToSave = Object.assign({}, this.currObjekt);
        this.saveDefaultFormValuesToObject(objectToSave);
        this.saveFormValuesToObject(objectToSave, this.mySwissFieldsObjectDetailLinks);
        this.saveFormValuesToObject(objectToSave, this.mySwissFieldsObjectDetailRechts);
        this.saveFormValuesToObject(objectToSave, this.mySwissFieldsObjectExtensionLinks);
        this.saveFormValuesToObject(objectToSave, this.mySwissFieldsObjectExtensionRechts);

        // Das Objekt und die Felder müssen übergeben werden, damit ermittelt werden kann,
        // welche Felder dass aktualisiert werden müssen
        if (!this.allDynamicObjectFields) {
            return of();
        }
        if (updateFieldKey != '') {
            // Einzelnes Feld aktualisieren
            let dbField = '';
            if (updateFieldKey === 'manuDesc') {
                dbField = 'manufacturingDescription';
            } else if (updateFieldKey === 'memo') {
                dbField = 'memo';
            } else {
                const field = this.allDynamicObjectFields.filter((i) => i.options.key === updateFieldKey);
                if (field.length == 1 && field[0]?.options?.dataBinding) {
                    dbField = field[0].options.dataBinding;
                }
            }

            if (dbField == '') {
                return of();
            }

            if (dbField == 'ObjModifiedBy') {
                return of();
            }
            if (dbField == 'createdBy') {
                return of();
            }
            if (dbField == 'created') {
                return of();
            }
            if (dbField == 'modified') {
                return of();
            }
            if (dbField == 'modifiedBy') {
                return of();
            }
            if (dbField == 'totalHours') {
                return of();
            }
            if (dbField == 'objectNumber') {
                return of();
            }

            return this.svcObjekte.updateObjektField(objectToSave, dbField).pipe(tap((res) => {
            }), catchError((err) => {
                console.error('Das Objekt konnte nicht aktualisiert werden!!\n' + dbField + ' wurde nicht gefunden' + objectToSave, err);
                this.svcMessageBox.showError('Das Objekt konnte nicht aktualisiert werden!!\n' + dbField + ' wurde nicht gefunden' + objectToSave, '!! FEHLER !!');
                return throwError(() => {
                    return err;
                });
            }));
        } else {
            // Alle Objekt-Felder aktualisieren
            return this.svcObjekte.updateObjekt(objectToSave, this.allDynamicObjectFields.filter((i) => i.options.key !== 'ObjCreatedDate' && i.options.key !== 'ObjCreatedBy')).pipe(tap((res) => {

            }), catchError((err) => {
                console.error(err);
                this.svcMessageBox.showError('Das Objekt konnte nicht aktualisiert werden!!', '!! FEHLER !!');
                return throwError(() => {
                    return err;
                });
            }));
        }
    }

    private setObjectView(data) {
        this.svcSwissSettings.getServiceAppConfig().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(conf => {
            if (this.objektSearchView$.getValue() == 6) {
                if (conf.orderFilterObjView6) {
                    const filter = conf.orderFilterObjView6.split(',');
                    data = data.filter((o) => {
                        if (o.objectType != 3) {
                            return true;
                        }
                        return filter.includes(o.description || '');
                    });
                }
            }

            data.forEach(ele => ele.imageURL = ele.imageURL ?? ele.objectTypeImg);

            this.dataSourceObjListView = data;
            this.treeViewCache.setObjectListData(data);
            this.dataSubject2.next({data: this.dataSourceObjListView, online: true});

            this.initData();
        });
    }

    private emitObjectSelected(objectID: string) {
        requestAnimationFrame(async () => {
            if (!this.selectObjectEventEmitter.closed) {
                this.selectObjectEventEmitter.emit(objectID);
            }
            if (!this.selectObjectEventEmitter2.closed) {
                this.selectObjectEventEmitter2.emit(objectID);
            }
        });
    }

    private resetFormGroup() {
        if (this.formGrp.contains('manuDesc')) {
            this.formGrp.controls.manuDesc.patchValue(this.currObjekt.manufacturingDescription);
        }

        if (this.formGrp.contains('memo')) {
            this.formGrp.controls.memo.patchValue(this.currObjekt.memo);
        }

        if (this.allDynamicObjectFields) {
            this.allDynamicObjectFields.forEach((formItem) => {
                this.formGrp.controls[formItem.options.key!]?.patchValue(formItem.options.value);
            });
        }
    }

    private loadObjectByObjectID() {
        this.loadSingleObjekt(true);
        this.selectObjectEventEmitter.emit(this.svcObjekte.getCurrentObjectID());
    }

    private initData() {
        if (this.objektSearchView$.getValue() !== 4) {
            // Die Suchfeldbeschreibungen werden nur geladen, wenn nicht mit der erweiterten Objektsuche gearbeitet wird.
            if (this.helperService.isWebServiceAvailable()) {
                this.refreshSuchfeldBeschreibungen();
            } else {
                this.refreshOfflineSuchfeldBeschreibungen();
            }
        }


        if (this.sub) {
            this.sub.unsubscribe();
        }

        this.sub = this.route.params.subscribe({
            next: () => {
                if (this.svcObjekte.getCurrentObjectID()) {
                    this.svcObjekte.setCurrentObjectID(this.svcObjekte.getCurrentObjectID());
                }
            },
        });
    }

    private async loadObjektListView(): Promise<void> {
        // Anzeige mit Objektliste
        if (this.helperService.isWebServiceAvailable()) {
            this.svcObjekte.getObjectView(this.objektSearchView$.getValue()).subscribe({
                next: async (res: ObjektModels.ObjectListViewItem[]) => {
                    if (res) {
                        this.setObjectView(res);
                    }
                }, error: (error: string) => {
                    console.error('Fehler beim Ermitteln der ObjektView: ' + error);
                    this.svcMessageBox.showError('Fehler beim Ermitteln der ObjektView: ' + error, '!! Fehler !!');
                }
            });
        } else {
            const res = await this.svcObjekte.getOfflineObjects();
            if (res) {
                this.setObjectView(res);
            }
        }
    }

    private onNewBaseObjekt() {
        this.dataSourceObjektAdressen!.data = [];
        this.hasObjektPartner = 0;
        this.dataSourceObjektAktivitaeten!.data = [];
        this.formGrp = this.fb.group({}); // Damit keine alten Felder geladen werden
        this.hasObjektDokus = 0;

        // Objektdetails öffnen
        this.setExpandStateObjektDetails(0);

        // Objekterweiterung schliessen
        this.setExpandStateObjektErweiterung(1);

        // Objekt-Aktivitäten schliessen
        this.setExpandStateObjektAktivitaeten(1);

        // Objekt-Adressen öffnen
        this.setExpandStateObjektAdressen(0);

        // Dokumentinfos schliessen
        this.setExpandStateObjektDokuInfos(1);
    }

    private onObjektCreated(res) {
        if (!res) {
            return this.svcObjekte.showSaveErrorMessage();
        }

        if (res === 'canceled') {
            return;
        }

        const obj: ObjektModels.ObjektElement = res as ObjektModels.ObjektElement;
        this.svcObjekte.setCurrentObject(obj);

        this.svcObjekte.showSaveOKMessage();

        // type any to handle the typo in webService (｡◕‿‿◕｡)
        const d: TreeViewItemsResponseObject<any> | any = {
            id: 0,
            pid: obj.parentObject == null ? 1 : (parseInt(this.treeviewComponent?.findTreeNodeByObjectId(obj.parentObject)?.id || '0') || 0),
            expanded: true,
            expandend: true,
            hasChild: false,
            imageURL: this.svcObjekte.getObjektTypeImageURL(Number(obj.objectType)),
            name: obj.objectType == '2' || obj.objectType == '4' ? obj.objectNumber + ' ' + obj.description : obj.description,
            description: obj.description,
            objectID: obj.objectID,
            objectNr: obj.objectNumber
        };

        this.treeviewComponent?.insertNode(d);
        const node: TreeNode = new TreeNode(0, 0, obj.objectType == '2' || obj.objectType == '4' ? obj.objectNumber + ' ' + obj.description : obj.description, obj.objectID, obj.description, this.svcObjekte.getObjektTypeImageURL(Number(obj.objectType)));
        this.addNodeEventEmitter.emit({node, parentObjID: obj.parentObject || ''});
        this.treeViewCache.addEntry(d);
    }

    private delObjekt() {
        const parentObjectID = this.svcObjekte.getCurrentObject().parentObject;
        // Service-App: Wenn in den Einstellungen ein Standard-Objekt definiert ist,
        // dann müssen erfasste Zeiten auf das Standard-Objekt genommen werden.

        this.svcObjekte.deleteObjekt(this.svcObjekte.getCurrentObject()).subscribe({
            next: async () => {
                // Item aus TreeView entfernen
                this.deleteNodeEventEmitter.emit(this.currObjekt.objectID);
                this.treeViewCache?.deleteEntry(this.currObjekt.objectID);

                // Suchbeschreibungen neu laden
                this.removeSuchfeldBeschreibungen();

                this.objectDataLoaded = false;
                if (parentObjectID) {
                    this.svcObjekte.getObjektByID(parentObjectID).subscribe({
                        next: (parent) => {
                            this.svcObjekte.setCurrentObject(parent);
                            this.loadSingleObjekt(true);
                        }
                    });
                } else {
                    this.cleanObjectData();
                }
                this.svcMessageBox.showSuccess('Das Objekt wurde erfolgreich gelöscht. ', 'Erfolgreich');
            }, error: (err: any) => {
                console.error(err);
                this.svcMessageBox.showError('Das Objekt konnte nicht gelöscht werden!!', '!! FEHLER !!');
                this.svcMessageBox.showErrorOK(err.error.ex, '!! FEHLER !!');
            }
        });
    }

    private async loadSingleObjekt(blShowObjektInTreeview: boolean = false, value?: any) {
        this.objectDataLoaded = false;

        if (this.helperService.isWebServiceAvailable()) {
            this.svcObjekte.getObjektByID(this.svcObjekte.getCurrentObjectID()).subscribe({
                next: (res: ObjektModels.ObjektElement) => {
                    // Prüfen ob ein Passwortschutz vorhanden ist.
                    this.svcObjekte.checkObjectPW(res).then((val) => {
                        // val ist true, wenn kein Kennwort vorhanden ist, oder das Passwort richtig eingegeben wurde
                        if (val) {
                            this.currObjekt = res;
                            if (value) {
                                this.treeView?.expandedNodes.push(value.id.toString());
                                this.treeView?.expandAll(this.treeView.expandedNodes);
                            }
                            this.setExpandStateObjektDetails(0); // Panel Objekt-Details öffnen

                            if (this.objektSearchView$.getValue() !== 1) {
                                this.setExpandStateObjektStruktur(0); // Panel Objekt-Struktur öffnen
                            }

                            // via Service den anderen Komponenten das Objekt mitteilen
                            this.svcObjekte.setCurrentObject(this.currObjekt);
                            this.loadObjektAdditionalData(blShowObjektInTreeview);
                        } else {
                            this.cleanObjectData();
                        }
                    });
                }, error: () => {
                    // This creates an endless loop if webservice isn't available when online state hasnt changed yet
                    this.helperService.setOnlineState(false);
                    this.ngOnInit();
                },
            });
        } else {
            this.svcObjekte.getOfflineObjektByID(this.svcObjekte.getCurrentObjectID()).subscribe({
                next: (obj: ObjektModels.ObjektElement) => {
                    if (obj) {
                        // Prüfen ob ein Passwortschutz vorhanden ist.
                        this.svcObjekte.checkObjectPW(obj).then(async (val) => {
                            // val ist true, wenn kein Kennwort vorhanden ist, oder das Passwort richtig eingegeben wurde
                            if (val) {
                                this.currObjekt = obj!;

                                this.setExpandStateObjektDetails(0); // Panel Objekt-Details öffnen
                                if (this.objektSearchView$.getValue() !== 1) {
                                    this.setExpandStateObjektStruktur(0); // Panel Objekt-Struktur öffnen
                                }

                                // via Service den anderen Komponenten das Objekt mitteilen
                                this.svcObjekte.setCurrentObject(this.currObjekt);
                                // Formularwerte neu setzen --> DataBinding
                                await this.fillFormDataValues();
                                // Objektadressen laden
                                await this.reloadObjektAdressen();
                                // Objekt-Aktivitäten (Dokumente) laden
                                await this.reloadObjektAktivitaeten();
                            } else {
                                this.cleanObjectData();
                            }
                        });
                    }
                }, error: () => {
                },
            });
        }
    }

    private async openPDFViewer(docID, fileName: string, description: string, type: DokumentModels.DokumentTyp = DokumentTyp.Dokument, source: DokumentModels.DokumentSource = DokumentSource.FromWebService, date = new Date()): Promise<void> {
        const pdfList = this.dataSourceObjektAktivitaeten.data.filter(activity => activity.imageFile === 'pdf.png').flatMap<DokumentInfo>(pdfActivity => {
            return {
                objectID: pdfActivity.objectID,
                documentID: pdfActivity.id,
                description: pdfActivity.description,
                fileName: pdfActivity.documentName,
                dokumentTyp: DokumentTyp.Notizblatt,
                dokumentQuelle: DokumentSource.FromWebService,
                lastModified: new Date()
            };
        });
        this.svcDokuData.setPDFDokument(this.svcObjekte.getCurrentObjectID(), docID, fileName, description, type, source, date, pdfList);
        this.svcObjekte.setCurrentObject(this.currObjekt, true);
        const res = await this.localStorageService.get('pfd_dialog_objects', 'SwissWebConfigDB', false, false);
        if (res) {
            const dialog = this.dialog.open(PDFViewerDialogComponent, {
                maxWidth: '100vw', maxHeight: '100vh', height: '100%', width: '100%', data: {isDialogMode: true}
            });
            dialog.afterClosed().subscribe({
                next: async () => {
                    await this.reloadObjektAktivitaeten();
                }
            });
        } else {
            await this.router.navigate(['pdfviewer', docID]);
        }
    }
} // Ende Component
